export class FleetOptions {
    own_damage: number = null;
    fire_theft: number = null;
    third_party: number = null;
}
